<template>
    <modal
        :name="name"
        transition="pop-out"
        :width="800"
        height="auto"
        scrollable
        :id="name"
        :adaptive="true"
        @before-open="emitOpened"
    >
        <div class="card m-0">
            <div class="card-header">
                <div class="row">
                    <div class="col-10">
                        <h2>{{title}}</h2>
                        <p v-if="subtitle" class="text-muted mb-0">{{ subtitle }}</p>
                    </div>
                    <div class="col-2">
                        <button type="button" class="close" @click.prevent="close()">
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <slot></slot>
            </div>
            <div class="card-footer text-right">
                <slot name="footer">
                    <Button type="button" name="button" @click.prevent="close()">{{ $t('recordatorios.cerrar') }}</Button>
                </slot>
            </div>
        </div>
    </modal>
</template>

<script>
    export default {
        props: {
            name: String,
            title: String,
            subtitle: String
        },
        methods: {
            close() {
                this.$modal.hide(this.name);
                this.$emit('close');
            },
            emitOpened() { 
                this.$emit('opened');
            }
        }
    }
</script>
